import React from 'react';
import { Query } from 'react-apollo';
import { curry, get } from 'lodash';

import caseRequestAssetsQuery from './caseRequestAssetsQuery';

export const buildQueryChild = curry(
  (WrapperComponent, componentProps, { data, loading }) => {
    const primaryAsset = get(data, 'case.primaryAsset');
    const caseRelatedAssets = get(data, 'case.relatedAssets', []);

    const assets = [primaryAsset, ...caseRelatedAssets];

    const options = assets
      .filter(asset => {
        const { assetType, unitNumber, trailerType } = asset || {};

        return [assetType, unitNumber, trailerType].some(Boolean);
      })
      .map(asset => ({ ...asset, title: asset.unitNumber }));

    return (
      <WrapperComponent
        {...componentProps}
        options={options}
        isLoading={!!loading}
      />
    );
  },
);

const withRequestAssets = WrappedComponent => componentProps => (
  <Query
    skip={!componentProps.caseNumber}
    query={caseRequestAssetsQuery}
    variables={{ caseNumber: componentProps.caseNumber }}
  >
    {buildQueryChild(WrappedComponent, componentProps)}
  </Query>
);

export default withRequestAssets;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/BaseRequestLinesTable/UnitOptionsDropdownCell/withRequestAssets.js